export { default } from './Switch';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Switch/index.js
// module id = 852
// module chunks = 2